import React, { useState } from 'react'
import { Popup } from '../../components/Popup'
import { Button } from '../../components/Button';
import {setRouteComment } from '../../redux/advertSlice';
import { Input } from '../../components/Input';
import { useDispatch } from 'react-redux';

export const RouteCommentPopup = ({closeFn, data, routeData}) => {
    const dispatch = useDispatch();
    const {prom, route, finish} = routeData;
    const [comment, setComment] = useState(data.comment);

    const setCommentHandler = () => {

        const body = finish ? {finishId: finish, comment} : {promoterId: prom, routeId: route, comment}
        dispatch(setRouteComment({body, resetFn: closeFn}));
    }

    return (
      <Popup title='Комментарий к маршруту' closeFn={closeFn} button={<Button text='Сохранить' onClick={setCommentHandler}/>}>
            <div className='route-comment-popup'>
                <Input label='Комментарий' value={comment} changeHandler={(e) => setComment(e.target.value)}/>
            </div>
    </Popup>
    )
}
